import {
  FRAuth,
  FRUser,
  TokenManager,
  UserManager,
  Config,
} from '@forgerock/javascript-sdk'
import { toast } from 'react-toastify'
import BanIcon from '../assets/images/icons/Ban'
import { ERROR_MESSAGES } from './errorMessages'
import { extractword } from '.'
import { eventDataLayer } from '../commons/utils'

let mail = ''

export const ResetPasswordOnReact = (username, dispatch, maggiorTutela) => {
  const FATAL = 'Fatal'
  const BASEURL = process.env.REACT_APP_FR_BASE_URL
  const REDIRECTURI = 'https://' + window.location.host + '/callback_fr.html'
  const TREENAME = process.env.REACT_APP_FR_RESET_PASSWORD_TREENAME
  //id del blocco popup
  const LOGINBLOCKCONTAINER = '#a2a-login-block-login'
  //id del pulsante click
  const LOGINBUTTONCLASS = '.login-action'
  Config.set({
    clientId: 'AENDrupalClient', // e.g. 'ForgeRockSDKClient'
    redirectUri: REDIRECTURI, // e.g. 'https://sdkapp.example.com:8443/_callback'
    scope: 'openid profile email', // e.g. 'openid profile me.read'
    serverConfig: {
      baseUrl: BASEURL, // e.g. 'https://openam.example.com:9443/openam/'
      timeout: 90000, // 90000 or less
    },
    realmPath: 'AENMobile', // e.g. 'root'
    tree: TREENAME, // e.g. 'Login'
    tokenStore: 'sessionStorage',
  })

  /** 1 - SCRIPT DA SOSTITUIRE IN WEKIT E OPENCMS, mappare funzione di login al popup attuale, richiamare qui **/

  const logout = async () => {
    try {
      await FRUser.logout()
      window.location.reload(true)
    } catch (error) {
      console.error(error)
    }
  }

  // Show only the view for this handler
  const showStep = (handler) => {
    return true
  }

  // Define custom handlers to render and submit each expected step
  const handlers = {
    UsernamePassword: (step) => {
      const panel = document.querySelector('#UsernamePassword')
      panel.querySelector('.btnhidden').addEventListener('click', () => {
        //Raf: retrieve delle callback necessarie
        const nameCallback = step.getCallbackOfType('NameCallback')
        const passwordCallback = step.getCallbackOfType('PasswordCallback')
        //Raf: ad ogni callback associo l'elemento del DOM
        nameCallback.setName(panel.querySelector('input[type=text]').value)
        passwordCallback.setPassword(
          panel.querySelector('input[type=password]').value
        )
        nextStep(step)
      })
    },
    firstStep: (step) => {
      console.log('FirstStepDetected')
      console.log('inputin')
      const StringAttributeInputCallback = step.getCallbackOfType(
        'StringAttributeInputCallback'
      )
      StringAttributeInputCallback.setValue('WEB')
      //Raf: retrieve delle callback necessarie
      const nameCallback = step.getCallbackOfType('NameCallback')
      //Raf: ad ogni callback associo l'elemento del DOM
      nameCallback.setName(username)
      nextStep(step)
    },
    firstStepRecaptcha: (step) => {
      console.log('firstStepRecaptchaDetected')
      console.log('inputin')
      const StringAttributeInputCallback = step.getCallbackOfType(
        'StringAttributeInputCallback'
      )
      StringAttributeInputCallback.setValue('WEB')
      //Raf: retrieve delle callback necessarie
      const nameCallback = step.getCallbackOfType('NameCallback')
      //Raf: ad ogni callback associo l'elemento del DOM
      nameCallback.setName(username)

      // ReCaptchaCallback.
      console.log('RecaptchaCallback start')
      const RecaptchaCallback = step.getCallbackOfType('ReCaptchaCallback')
      const siteKey = RecaptchaCallback.getSiteKey()
      const captchaApiUri =
        RecaptchaCallback.payload.output[1].value + '?render=' + siteKey
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.onload = function () {
        // eslint-disable-next-line no-undef
        grecaptcha.ready(function () {
          // eslint-disable-next-line no-undef
          grecaptcha
            .execute(siteKey, { action: 'submit' })
            .then(function (token) {
              RecaptchaCallback.setResult(token)
              nextStep(step)
            })
        })
      }
      script.src = captchaApiUri
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    secondStep: (step) => {
      console.log('SecondStepDetected')
      let word = extractword(
        step.getCallbackOfType('TextOutputCallback').payload.output[0].value,
        'message.innerHTML',
        ';'
      )
      if (word) {
        let mailDirty = word.split("message.innerHTML = '")
        if (mailDirty && mailDirty[1]) {
          mail = mailDirty[1].split("'")[0]
        }
      }
      nextStep(step)
    },
    thirdStep: (step) => {
      console.log('ThirdStepDetected')
      const ChoiceCallback = step.getCallbackOfType('ChoiceCallback')
      // ad ogni callback associo l'elemento del DOM
      ChoiceCallback.setInputValue(maggiorTutela ? '1' : '0')
      nextStep(step)
    },
    successStep: (step) => {
      console.log('successStepDetected')

      const hasError = step.payload?.code && step.payload?.message

      const errorString = `${step.payload?.code}_${step.payload?.message}`
        .toLocaleLowerCase()
        .replaceAll(' ', '_')

      if (window && window.dataLayer) {
        eventDataLayer(
          hasError
            ? {
                event: 'process_ko',
                stream: 'web',
                azione: 'recupero_password',
                error_type: errorString,
                sezione: 'login',
              }
            : {
                event: 'process_ok',
                stream: 'web',
                azione: 'recupero_password',
                sezione: 'login',
              }
        )
      }

      document.querySelector('#loader-scripts').classList.remove('visible')
      if (mail) {
        dispatch({
          type: 'changeShowThankYouPage',
          payload: { type: 'resetPassword', field: mail },
        })
      } else {
        dispatch({
          type: 'changeShowThankYouPage',
          payload: { type: 'resetPassword', field: username },
        })
      }
    },
    StringAttributeInputCallback: (step) => {
      const panel = document.querySelector('#FirstStringAttributeInputCallback')
      const StringAttributeInputCallback = step.getCallbackOfType(
        'StringAttributeInputCallback'
      )
      StringAttributeInputCallback.setValue('WEB')
      nextStep(step)
    },
    MigrationError4: (step) => {
      const panel = document.querySelector('#MigrationError4')
      console.log('SAP_MIGRATION_ERROR')
      console.log(step)
      toast.dismiss()
      toast.error(ERROR_MESSAGES.sap4MigrationError, {
        autoClose: false,
        icon: BanIcon,
      })
      document.querySelector('#loader-scripts').classList.remove('visible')
      nextStep(step)
    },
    OtpEmailInner: (step) => {
      const panel = document.querySelector('#OtpEmailInner')
      console.log('OTPEMAIL')
      console.log(step)
      document.body.classList.add('otp-email-step')
      panel.querySelector('.btnhidden').addEventListener('click', () => {
        const passwordCallback = step.getCallbackOfType('PasswordCallback')
        passwordCallback.setPassword(panel.querySelector('input').value)
        nextStep(step)
      })
    },
    LoginStep1: (step) => {
      const panel = document.querySelector('#LoginStep1')
      panel.querySelector('.btnhidden').addEventListener('click', () => {
        //Raf: retrieve delle callback necessarie
        const nameCallback = step.getCallbackOfType('NameCallback')
        const ValidatedCreatePasswordCallback = step.getCallbackOfType(
          'ValidatedCreatePasswordCallback'
        )
        const SelectIdpCallback = step.getCallbackOfType('SelectIdPCallback')
        SelectIdpCallback.setInputValue('localAuthentication')

        //Raf: ad ogni callback associo l'elemento del DOM
        nameCallback.setName(username)
        ValidatedCreatePasswordCallback.setPassword(
          panel.querySelector('input[type=password]').value
        )
        nextStep(step)
      })
    },
    Error: (step) => {
      //@todo ampliare gestione codice errore
      if (step.getMessage().indexOf('Locked out')) {
        toast.dismiss()
        toast.error(
          maggiorTutela
            ? ERROR_MESSAGES.passwordResponseMaggiorTutela
            : ERROR_MESSAGES.passwordResponse,
          { autoClose: false, icon: BanIcon }
        )
        document.querySelector('#loader-scripts').classList.remove('visible')
      } else {
        toast.dismiss()
        toast.error(step.getCode(), { autoClose: false, icon: BanIcon })
        document.querySelector('#loader-scripts').classList.remove('visible')
      }
    },
    [FATAL]: (step) => {},
  }

  const showUser = (user) => {
    document.querySelector('#User pre').innerHTML = JSON.stringify(
      user,
      null,
      2
    )
    const panel = document.querySelector('#User')
    panel.querySelector('.btnhidden').addEventListener('click', () => {
      logout()
    })
    showStep('User')
  }

  const getStage = (step) => {
    // RAF: ottengo tutte le callback che e vedo se lo step le contiene
    const passwordCallbacks = step.getCallbacksOfType('PasswordCallback')
    const stringAttributeInputCallback = step.getCallbacksOfType(
      'StringAttributeInputCallback'
    )
    const SelectIdPCallback = step.getCallbacksOfType('SelectIdPCallback')
    const choiceCallback = step.getCallbacksOfType('ChoiceCallback')
    const ValidatedCreatePasswordCallback = step.getCallbacksOfType(
      'ValidatedCreatePasswordCallback'
    )
    const NameCallback = step.getCallbacksOfType('NameCallback')
    const TextOutputCallbacks = step.getCallbacksOfType('TextOutputCallback')
    const hiddenValueCallback = step.getCallbacksOfType('HiddenValueCallback')
    const ReCaptchaCallback = step.getCallbacksOfType('ReCaptchaCallback')
    const SuspendedTextOutputCallback = step.getCallbacksOfType(
      'SuspendedTextOutputCallback'
    )
    if (SuspendedTextOutputCallback.length > 0) {
      return 'successStep'
    }
    if (
      NameCallback.length > 0 &&
      stringAttributeInputCallback.length > 0 &&
      ReCaptchaCallback.length > 0
    ) {
      return 'firstStepRecaptcha'
    } else if (
      NameCallback.length > 0 &&
      stringAttributeInputCallback.length > 0
    ) {
      return 'firstStep'
    }
    if (TextOutputCallbacks.length > 0 && hiddenValueCallback.length > 0) {
      return 'secondStep'
    }
    if (choiceCallback.length > 0) {
      return 'thirdStep'
    }

    return undefined
  }

  // Display and bind the handler for this stage
  const handleStep = async (step) => {
    switch (step.type) {
      case 'LoginSuccess':
        document.body.classList.add('login-success-temp')
        // If we have a session token, get user information
        const sessionToken = step.getSessionToken()
        const tokens = await TokenManager.getTokens({
          forceRenew: true,
        })
        const user = await UserManager.getCurrentUser()
        const nomeutente = user.given_name
        /** fine solo drupal **/
        return showUser(user)

      case 'LoginFailure':
        handlers['successStep'](step)
        return

      default:
        const stage = getStage(step) || FATAL
        if (!showStep(stage)) {
          showStep(FATAL)
          handlers[FATAL](step)
        } else {
          handlers[stage](step)
        }
    }
  }
  const handleFatalError = (err) => {
    console.error('Fatal error', err)
    showStep(FATAL)
  }

  // Get the next step using the FRAuth API
  const nextStep = (step) => {
    FRAuth.next(step).then(handleStep).catch(handleFatalError)
  }

  /**
   * 3 - ATOS/WEKIT METODO DA RICHIAMARE AL LOGOUT
   */
  // Begin the login flow
  nextStep()
}
